import {
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

import { CommonModule }
from '@angular/common';

import { FormGroup }
from '@angular/forms';

import { Parser }
from 'expr-eval';

import { TransactionActionService } from '../../../core/services/system/transaction-action.service';
import { DynamicFieldService } from '../../../core/services/dynamic-field.service';
import { ValidationEngineService } from '../../../core/services/validation-engine.service';
import { Router } from '@angular/router';
import { SchemaApiService } from '../../../core/services/schema-api.service';

declare var KTToast: any;
@Component({
  selector: 'app-transaction-toolbar',
  standalone: true,
  imports: [CommonModule],
  templateUrl:'./transaction-toolbar.component.html'
})
export class TransactionToolbarComponent {

  @Input() actions: any[] = [];

  @Input() form!: FormGroup;

  @Input() layout: any;

  @Input() entity!: string;

  @Input() recordId?: string;

  // @Output() saved = new EventEmitter<void>();

  private parser = new Parser();

  loading = false;

  constructor(
    private actionSvc: TransactionActionService,
    private api:SchemaApiService,
    private dfs:DynamicFieldService,
    private validationEngine:ValidationEngineService,
    private router:Router
  ) {}

  ngOnInit() {

    console.log(
      'TOOLBAR RECORD ID',
      this.recordId
    );

    console.log(
      'TOOLBAR ACTIONS',
      this.actions
    );
  }

  private getExpressionContext(): any {

    return {

      header:
        this.form.getRawValue(),

      recordId:
        this.recordId ?? '',

      isNew:
        !this.recordId,

      isEdit:
        !!this.recordId
    };
  }

  isVisible(action: any): boolean {

    if (!action.visibleWhen) {
      return true;
    }

    try {

      const ctx = {

        header:
          this.form.getRawValue(),

        recordId:
          this.recordId ?? '',

        isNew:
          !this.recordId,

        isEdit:
          !!this.recordId
      };

      console.log(
        'ACTION',
        action.name,
        action.visibleWhen
      );

      console.log(
        'CTX',
        ctx
      );

      const result =
        this.parser
          .parse(action.visibleWhen)
          .evaluate(ctx as any);

      console.log(
        'VISIBLE RESULT',
        action.name,
        result
      );

      return !!result;

    }
    catch (err) {

      console.error(
        'VISIBILITY ERROR',
        action.visibleWhen,
        err
      );

      return true;
    }
  }

  isDisabled(action: any): boolean {

    if (!action.disabledWhen)
      return false;

    try {

      return !!this.parser
        .parse(action.disabledWhen)
        .evaluate({
          header: this.form.getRawValue()
        });

    } catch {
      return false;
    }
  }

  execute(action: any) {

    switch (action.name) {

      case 'save':
        this.save();
        break;

      case 'update':
        this.update();
        break;

      case 'back':
        this.backToList();
        break;

      case 'reset':
        this.clearForm();
        break;

      default:
        this.executeApiAction(action);
        break;
    }
  }

  save() {

    this.api.getRules(
      this.entity
    )
    .subscribe({

      next:(rules:any[])=>{

        const formValue =
          this.form.getRawValue();

        const context = {

          header: formValue,

          lineItems:
            formValue.lines || []
        };

        const results =
          this.validationEngine
            .validate(
              context,
              rules
            );

        const errors =
          results.filter(
            (x:any)=>
              x.severity === 'ERROR'
          );

        if (
          errors.length > 0
        ) {

          this.showValidationErrors(
            errors
          );

          return;
        }

        this.executeSaveApi();
      }
    });
  }

  private executeSaveApi() {

    const payload =
      this.dfs.getSubmitPayload(
        this.form,
        this.layout
      );

    payload.moduleCode =
      this.layout.moduleCode;

    payload.tax = this.dfs.getTaxConfig(this.layout);

    const saveAction =
      this.actions.find(
        x =>
          x.name === 'save'
      );

    // this.actionSvc
    //   .execute(
    //     saveAction,
    //     payload
    //   )
     this.api.saveForm(
      this.entity,
      payload,
      )
      .subscribe({

        next:(res:any)=>{

          KTToast.show({

            message:
              saveAction.successMessage
              ||
              'Saved Successfully',

            appearance:'solid',

            variant:'success'
          });

          // this.saved.emit();
        },

        error:(err)=>{

          KTToast.show({

            message:
              err.message,

            appearance:'solid',

            variant:'danger'
          });
        }
      });
  }

  update() {

    if (
      !this.recordId
    ) {

      KTToast.show({

        message:
          'No record selected',

        variant:'danger',

        appearance:'solid'

      });

      return;
    }

    const payload =
      this.dfs
        .getSubmitPayload(
          this.form,
          this.layout
        );

    payload.moduleCode =
      this.layout.moduleCode;

    payload.tax = this.dfs.getTaxConfig(this.layout);

    const dto = {

      ...payload,

      Entity:
        this.entity
    };

    this.api.updateForm(
      this.entity,
      this.recordId,
      dto
    )
    .subscribe({

      next:()=>{

        KTToast.show({

          message:
            'Updated Successfully',

          variant:'success',

          appearance:'solid'

        });

        // this.saved.emit();
      },

      error:(err)=>{

        KTToast.show({

          message:
            err.message,

          variant:'danger',

          appearance:'solid'

        });

      }

    });
  }

  clearForm() {

    this.form.reset();
    //
    this.dfs.refreshAutoNumbers(
      this.form,
      this.layout
    );
  }

  backToList() {

    this.router.navigate([
      'app',
      this.layout.moduleCode.toLowerCase(),
      this.layout.transType.toLowerCase(),
      this.layout.entity.toLowerCase()
    ]);
  }

  private executeApiAction(
    action:any
  ) {

    if (
      action.confirm
    ) {

      const ok =
        confirm(
          `Execute ${action.label}?`
        );

      if (!ok) {
        return;
      }
    }

    const payload =
      this.dfs.getSubmitPayload(
        this.form,
        this.layout
      );

    this.loading = true;

    this.actionSvc
      .execute(
        action,
        payload
      )
      .subscribe({

        next:(res)=>{

          this.loading = false;

          KTToast.show({

            message:
              action.successMessage
              || 'Success',

            appearance:'solid',

            variant:'success'
          });

          console.log(res);

          // this.saved.emit();
        },

        error:(err)=>{

          this.loading = false;

          KTToast.show({

            message:
              err.message,

            appearance:'solid',

            variant:'danger'
          });

        }
      });
  }

  showValidationErrors(errors: any[]) {
    // 1. Get the first error (The Line Item error, thanks to your SQL sort)
    const firstError = errors[0];
    const message = firstError.message || firstError.Message;

    // 2. Trigger Metronic KTToast
    KTToast.show({
      icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-info-icon lucide-info"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>`,
      message: message,
      appearance: 'solid',
      variant: 'mono',
      duration: 5000,

    });
  }


}